import { Injectable, EventEmitter, OnInit } from '@angular/core';
// import { Observable } from 'rxjs/Rx';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

// Services
import * as srv from '../share/services';

@Injectable()
export class ActivateMain
  implements CanActivate {
  name = 'ActivateMain';
  constructor(
    private _userSrv: srv.UserService,
    private _helperSrv: srv.HelperService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
    'starting'.log(this.name);
    if (this._userSrv.getContact() === undefined) {
      this._helperSrv.goToLogin();
      return true;
    } else {
      return true;
    }
  }

}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/activates/main.activate.ts